
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/spark-line-chart",
      function () {
        return require("private-next-pages/x/api/charts/spark-line-chart.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/spark-line-chart"])
      });
    }
  